
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report1332ShopPaymentTypeRefTypeDialog extends Serenity.EntityDialog<Report1332ShopPaymentTypeRefTypeRow, any> {
        protected getFormKey() { return Report1332ShopPaymentTypeRefTypeForm.formKey; }
        protected getIdProperty() { return Report1332ShopPaymentTypeRefTypeRow.idProperty; }
        protected getLocalTextPrefix() { return Report1332ShopPaymentTypeRefTypeRow.localTextPrefix; }
        protected getNameProperty() { return Report1332ShopPaymentTypeRefTypeRow.nameProperty; }
        protected getService() { return Report1332ShopPaymentTypeRefTypeService.baseUrl; }
        protected getDeletePermission() { return Report1332ShopPaymentTypeRefTypeRow.deletePermission; }
        protected getInsertPermission() { return Report1332ShopPaymentTypeRefTypeRow.insertPermission; }
        protected getUpdatePermission() { return Report1332ShopPaymentTypeRefTypeRow.updatePermission; }

        protected form = new Report1332ShopPaymentTypeRefTypeForm(this.idPrefix);

    }
}